import { Skeleton } from "@/components/ui/skeleton";
import { GraficoLinhas } from "../GraficoLinhas";
import { useOverviewGeral, useOverviewGraficos } from "../api";
import { CORES, detalheAtivos, detalheCancelamentos, detalheVariacao, formatInteiro, formatNumero, seriesAbsoluto } from "../series";
import { GradeKpis, Kpi, type Variante } from "./Kpi";

/** Clientes: ativos, trials e cancelamentos, com o gráfico de ativos e cancelados. */
export function TelaGeral({ variante }: { variante: Variante }) {
  const tv = variante === "tv";
  const geral = useOverviewGeral({ autoAtualizar: tv });
  const graficos = useOverviewGraficos({ autoAtualizar: tv });
  const absoluto = seriesAbsoluto(graficos.data);

  const grafico = absoluto ? (
    <GraficoLinhas titulo="Ativos e cancelados" {...absoluto} formatValor={formatInteiro} variante={variante} />
  ) : (
    <Skeleton className={tv ? "h-full w-full rounded-xl bg-white/10" : "h-[22rem] w-full rounded-xl"} />
  );

  return (
    <div className={tv ? "flex h-full flex-col gap-8" : "space-y-4"}>
      <GradeKpis variante={variante} colunas={3}>
        <Kpi
          rotulo="Ativos"
          valor={formatNumero(geral.data?.ativos)}
          isLoading={geral.isLoading}
          variante={variante}
          cor={CORES.verde}
          detalhe={detalheAtivos(geral.data, graficos.data)}
        />
        <Kpi
          rotulo="Trials"
          valor={formatNumero(geral.data?.trials)}
          isLoading={geral.isLoading}
          variante={variante}
          cor={CORES.amarelo}
          detalhe={detalheVariacao(geral.data?.trialsMesAtual, "no mês")}
        />
        <Kpi
          rotulo="Cancelamentos no ano"
          valor={formatNumero(geral.data?.cancelamentosAnoAtual)}
          isLoading={geral.isLoading}
          variante={variante}
          cor={CORES.vermelho}
          detalhe={detalheCancelamentos(geral.data)}
        />
      </GradeKpis>
      {tv ? <div className="min-h-0 flex-1">{grafico}</div> : grafico}
    </div>
  );
}
